import { mainApi } from "services/main";
import {
  ListDocumentsRequest,
  ListDocumentsResponse,
  GetDocumentByIdResponse,
  GetDocumentByIdRequest,
  DownloadUrlResponse,
  DownloadUrlRequest,
  UpdateDocumentRequest,
  UpdateDocumentResponse,
  DeleteDocumentRequest,
  DeleteDocumentResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    listDocuments: builder.query<ListDocumentsResponse, ListDocumentsRequest>({
      query: (request: ListDocumentsRequest) => ({
        url: "documents/" + encodeURIComponent(request.parentId),
      }),
      providesTags: ["Documents"],
      extraOptions: {
        delay: 2000,
      },
    }),
    getDocumentById: builder.query<
      GetDocumentByIdResponse,
      GetDocumentByIdRequest
    >({
      query: (request: GetDocumentByIdRequest) => ({
        url: "document/" + request.documentId,
      }),
    }),
    downloadUrl: builder.query<DownloadUrlResponse, DownloadUrlRequest>({
      query: (request: DownloadUrlRequest) => ({
        url: "documents/download-url/" + request.documentId,
        params: {
          preview: request.preview,
        },
      }),
    }),
    updateDocument: builder.mutation<
      UpdateDocumentResponse,
      UpdateDocumentRequest
    >({
      query: (request: UpdateDocumentRequest) => ({
        url: "document/" + request.documentId,
        body: request,
        method: "PUT",
      }),
      invalidatesTags: ["Documents"],
    }),
    updateDocumentForMove: builder.mutation<
      UpdateDocumentResponse,
      UpdateDocumentRequest
    >({
      query: (request: UpdateDocumentRequest) => ({
        url: "document/" + request.documentId,
        body: request,
        method: "PUT",
      }),
    }),
    deleteDocument: builder.mutation<
      DeleteDocumentResponse,
      DeleteDocumentRequest
    >({
      query: (request: DeleteDocumentRequest) => ({
        url: "document/" + request.documentId,
        method: "DELETE",
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListDocumentsQuery,
  useGetDocumentByIdQuery,
  useDownloadUrlQuery,
  useLazyDownloadUrlQuery,
  useUpdateDocumentMutation,
  useUpdateDocumentForMoveMutation,
  useDeleteDocumentMutation,
} = extendedApi;
